// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender'); // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule.wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var TestTarget = Sephora.Util.InflatorComps.Comps['TestTarget'].class; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
TestTarget.prototype.shouldComponentUpdate = wrapComponentRenderModule.shouldComponentUpdate; // eslint-disable-line max-len
/* eslint-disable max-len */
const store = require('Store');
const watch = require('redux-watch');
const Events = require('utils/framework/Events');
const TEST_TYPES = require('utils/TestTarget').TEST_TYPES;
const TestTargetActions = require('actions/TestTargetActions');
const Helpers = require('utils/Helpers');
const isObject = Helpers.isObject;
const deepExtend = require('utils/deepExtend');
const bccTestsUtil = require('utils/bccTests');

const areObjectsEq = (obj1, obj2) => {
    return (obj1 === obj2 || JSON.stringify(obj1) === JSON.stringify(obj2));
};

/**
  * T&T tested components may need to be explicitly added here in case they haven't been required
  * by another component (meaning it does not yet exist in the component library).
  *
  * These require statements are wrapped in require.ensure so that the required component
  * and its dependencies are not included in the priority bundle. They are added to the
  * components chunk instead.
  */

// require.ensure([], function(require) {
//     if (!Sephora.isNodeRender) {
//         Sephora.Util.InflatorComps.Comps.Test = function () {
//             return require('components/Test/Test');
//         };
//      }
// }, 'components');

TestTarget.prototype.loadClass = function () {
    const resolvePromise = (resolve, reject) => {
        if (Sephora.Util.InflatorComps.Comps[this.props.testComponent]) {
            resolve();
        } else {
            Events.onLastLoadEvent(window, [Events.InPageCompsCtrlrsApplied], () => {
                if (Sephora.Util.InflatorComps.Comps[this.props.testComponent]) {
                    resolve();
                } else {
                    //checks for PostLoaded components
                    Events.onLastLoadEvent(window, [Events.PostLoad], () => {
                        Sephora.Util.InflatorComps.Comps[this.props.testComponent] ? resolve() : reject();
                    });
                }
            });
        }
    };

    return new Promise((resolve, reject) => {
        if (this.isBCCConfigDrivenTest) {
            resolvePromise(resolve, reject);
        } else {
            Events.onLastLoadEvent(
                window,
                [Events.TestTargetReady],
                () => {
                    resolvePromise(resolve, reject);
                }
            );
        }
    });
};

TestTarget.prototype.ctrlr = function () {

    this.isBCCConfigDrivenTest = bccTestsUtil.findTestInObject(
        Sephora.configurationSettings.ABTests, this.props.testName
    );

    this.loadClass().then(() => {
        this.executeTest();

        // if this test is BCC test -> execute it and do not subscribe, since
        // it should not be overwritten by the adobe test with the same name and
        // we don't need to hide it later on SPA load as it is consistent across pages
        // https://jira.sephora.com/browse/ILLUPH-114099?focusedCommentId=1080558#comment-1080558
        if (this.isBCCConfigDrivenTest) {
            return;
        }

        // Subscribe to T&T updates
        const testTargetWatch = watch(store.getState, 'testTarget');

        store.subscribe(testTargetWatch((newState) => {
            const offersInitialized = newState.readyState === TestTargetActions.OFFERS_READY_STATES.ADOBE_TESTS_RECEIVED;
            // adobe tests received and have been changed from the previous state
            if (offersInitialized && !areObjectsEq(this.prevTestTargetOffers, newState?.offers)) {
                this.executeTest();
            // tests has been reset
            } else if (!offersInitialized) {
                this.setState({ displayComponent: null,
                    showSkeleton: false
                });
            }
        }), this);

    }, () => {
        /* TODO: Find an optimal solution for edge cases where the component class
        may not be available yet. */
        const warning = 'TestTarget: %s component class was not found, rendering empty instead.';
        return console.error(warning, this.props.testComponent);
    });
};

TestTarget.prototype.executeTest = function () {
    const results = store.getState().testTarget;

    this.prevTestTargetOffers = results.offers;

    const testResults = this.getTestResults(results);
    const testEligible = this.props.testName && this.props.testEnabled && testResults;

    if (!results.timeout && testEligible) {
        /* Handle pre-determined test cases */
        if (testResults.currentTest.testType !== undefined) {

            switch (testResults.currentTest.testType) {
                case TEST_TYPES.REORDERING:

                    /* Retrieve the name of the component that is supposed to swap with
                    this instance. */

                    if (this.props.name in testResults.currentTest.arrangement) {
                        const replacementComponent = testResults.currentTest.arrangement[this.props.name];

                        this.registerSwapComponents(testResults.currentTest, testResults.testName).then(
                            components => this.handleComponentSwap(components, replacementComponent),
                            err => this.defaultToControl(err)
                        );
                    } else {
                        this.defaultToControl();
                    }
                    break;
                case TEST_TYPES.TOGGLE:
                    if (this.shouldHideComponent(testResults.currentTest.result)) {
                        this.setState({
                            componentHidden: true,
                            showSkeleton: false
                        });
                        /* If component is to be hidden, returns to remain <Empty> and sets
                        componentHidden flag to hide bccStyleWrapper. */
                        return;
                    } else {
                        this.setState({
                            displayComponent: Sephora.Util.InflatorComps.Comps[this.props.testComponent].getReactClass(),
                            updateProps: false,
                            showSkeleton: false
                        });
                        break;
                    }
                case TEST_TYPES.INJECT_PROPS:
                    this.injectProps(testResults);
                    break;

                case TEST_TYPES.TOGGLE_AND_INJECT_PROPS:
                    if (this.shouldHideComponent(testResults.currentTest.result)) {
                        this.setState({
                            componentHidden: true,
                            showSkeleton: false
                        });
                        /* If component is to be hidden, returns to remain <Empty> and sets
                        componentHidden flag to hide bccStyleWrapper. */
                        return;
                    } else {
                        this.injectProps(testResults);
                    }
                    break;

                case TEST_TYPES.SWAP_EXPERIENCE:
                    if (testResults.currentTest.result.experience === 'new') {
                        this.setState({ displayComponent: Sephora.Util.InflatorComps.Comps[testResults.currentTest.result.component].getReactClass(),
                            showSkeleton: false
                        });
                        return;
                    }
                    break;

                default:
                    this.defaultToControl();
                    break;
            }

            /* Handle hard-coded tests */
        } else {
            this.setState({
                displayComponent: Sephora.Util.InflatorComps.Comps[this.props.testComponent].getReactClass(),
                updateProps: { testTarget: { [testResults.testName]: testResults.currentTest } },
                showSkeleton: false
            });
        }

        if (this.props.testCallback) {
            /* Hook to execute a callback when the test executes, useful for state changes */
            this.props.testCallback(testResults.testName);
        }

    } else {
        /* Default to control if:
        ** 1. Test is disabled
        ** 2. testName was not passed
        ** 3. No matching result in store
        ** 4. Test flag is false in store
        ** 5. T&T service timeouts
        */
        this.defaultToControl();
    }
};

TestTarget.prototype.injectProps = function (testResults) {
    if (testResults.currentTest.props) {
        let newProps = this.getNewProps(
            this.props,
            testResults.currentTest.props,
            testResults.testName
        );

        if (newProps) {
            let {
                testName,
                testComponent,
                testEnabled,
                ...originalProps
            } = this.props;

            this.setState({
                displayComponent: Sephora.Util.InflatorComps.Comps[this.props.testComponent].getReactClass(),
                updateProps: deepExtend({}, originalProps, newProps),
                showSkeleton: false
            });
        } else {
            this.defaultToControl();
        }
    } else {
        this.defaultToControl();
    }
};

TestTarget.prototype.getTestResults = function (results) {
    //TODO: BCC and API should return an array of tests
    const testNames = this.props.testName ? this.props.testName.split(',') : [];

    let testResults = [];

    testNames.forEach(name => {
        const trimmedName = name.trim();

        if (results.offers[trimmedName]) {
            testResults.push({
                testName: trimmedName,
                currentTest: results.offers[trimmedName]
            });
        }
    });

    if (testResults.length) {
        return testResults.pop();
    } else {
        return false;
    }
};

TestTarget.prototype.defaultToControl = function (error) {
    let defaultProps;

    if (this.props.isBcc) {
        defaultProps = this.props;
    } else {
        defaultProps = { testTarget: false };
    }

    /* Render component as control case */
    this.setState({
        displayComponent: Sephora.Util.InflatorComps.Comps[this.props.testComponent].getReactClass(),
        updateProps: defaultProps,
        showSkeleton: false
    });

    if (error) {
        console.error(error);
    }
};

/**
 * @param {object} currentTest - This test's corresponding object sent from T&T.
 */
TestTarget.prototype.shouldHideComponent = function (currentTest) {
    return typeof currentTest.isHidden !== 'undefined' && currentTest.isHidden;
};

/**
 * @param {array} components - This test's associated components.
 * @param {string} componentName - The name of the component to be swapped with (BCC property).
 */
TestTarget.prototype.handleComponentSwap = function (components, componentName) {

    /* Set the component's default setup as fallback. */
    let componentToRender = this.props.testComponent;
    let propsToRender = this.props;

    /* If there's no replaceComponent, then just hide the original one */
    if (!componentName) {
        this.setState({
            componentHidden: true,
            showSkeleton: false
        });
        return;
    }

    /* Filter the current test's component 'library' with the name of the component to be
    swapped with. */
    let replacement = components.filter(component => component.name === componentName);

    /* Ideally, the filtering will always return one component, however, we do a safety
    check in case there is a mismatch between the component names. If that is the case,
    it will render with the fallback set above. */
    if (replacement.length) {
        replacement = replacement.pop();

        /* Render this instance with the data of the component that it's being swapped with. */
        componentToRender = replacement.testComponent;
        propsToRender = replacement;
    }

    this.setState({
        displayComponent: Sephora.Util.InflatorComps.Comps[componentToRender].getReactClass(),
        updateProps: propsToRender,
        showSkeleton: false
    });
};

/**
 * @param {object} currentTest - This test's corresponding object sent from T&T.
 */
TestTarget.prototype.registerSwapComponents = function (currentTest, testName) {
    /* Send component data to store so other instances can make it their own. */
    let modifiedProps = Object.assign({}, this.props);
    modifiedProps.testName = testName;

    store.dispatch(TestTargetActions.setSwapComponent(modifiedProps));

    /* Wait until the tested component's data is registered in the store before starting
    ** to swap.
    */
    return new Promise((resolve, reject) => {
        const getSwapComponents = () => store.getState().testTarget.swaps[testName];

        /* Resolve only when all components being tested have been stored. */
        const componentsHaveBeenRegistered = (components = getSwapComponents()) =>
            components.length === currentTest.componentCount;

        if (componentsHaveBeenRegistered()) {
            resolve(getSwapComponents());
        } else {

            /* Default to control in case test setup was misconfigured. This will occur if the
            amount of BCC components asigned to a same test does not match the component count
            setting in the T&T result. */
            const TIMEOUT = 3000;
            setTimeout(() => {
                reject(`TestTarget: component test ${testName} has timeout.`);
            }, TIMEOUT);

            /* Watch for components being registered to swap. */
            const watcher = watch(store.getState, 'testTarget.swaps');
            store.subscribe(watcher(newVal => {
                if (componentsHaveBeenRegistered(newVal[testName])) {
                    resolve(newVal[testName]);
                }
            }), this);
        }
    });
};

/* Checks if invalid prop structure is being added to the tested component */
TestTarget.prototype.getNewProps = function (oldProps, newProps, testName) {
    let HTML_KEY = 'dangerouslySetInnerHTML';
    let CHILDREN_KEY = 'children';
    let HOTSPOTS_KEY = 'hotSpots';
    let invalidKeys = [];
    let copyNestedArrayItems = this.copyNestedArrayItems;
    let handleHotSpots = this.handleHotSpots;

    if (!isObject(oldProps) || !isObject(newProps)) {
        return null;
    }

    /* Create shallow copy to avoid mutating Redux object */
    newProps = Object.assign({}, newProps);

    (function getKeys(original, incoming) {
        Object.keys(incoming).forEach(key => {
            if (!Object.prototype.hasOwnProperty.call(original, key) ||
                key === HTML_KEY ||
                key === CHILDREN_KEY) {
                // Only keys that exist in the original prop structure are permitted
                invalidKeys.push(key);
            }
            if (Array.isArray(incoming[key]) && Array.isArray(original[key]) &&
                key !== HOTSPOTS_KEY) {

                /* We copy objects nested inside arrays or else they get flatten eventually when
                the objects are merged.*/

                incoming[key] = copyNestedArrayItems(incoming[key], original[key]);


            } else if (isObject(incoming[key])) {
                getKeys(original[key], incoming[key]);
            }
        });
        /* Hotspots array must be handled separately */
        if (original[HOTSPOTS_KEY]) {
            newProps[HOTSPOTS_KEY] = handleHotSpots(incoming, original);
        }

    }(oldProps, newProps));

    if (invalidKeys.length === 0) {
        return newProps;
    } else {
        let warning = 'TestTarget: invalid props %s are being added to %s test, defaulting to control.';
        console.error(warning, `(${invalidKeys.join(',')})`, testName);
        return null;
    }
};

TestTarget.prototype.handleHotSpots = function(incoming, original) {
    let HOTSPOTS_KEY = 'hotSpots';
    // If there is no hotspots key, return the original
    // If a user wishes to overwrite hotSpots to zero, they must pass []
    if (original[HOTSPOTS_KEY] && !incoming[HOTSPOTS_KEY]) {
        return original[HOTSPOTS_KEY];
    } else {
        // Otherwise, always overwrite the old hotSpots with the new
        return incoming[HOTSPOTS_KEY];
    }
};

TestTarget.prototype.copyNestedArrayItems = function (incoming, original) {
    return original.map((item, index) => {
        if (isObject(item) && isObject(incoming[index])) {
            return deepExtend({}, original[index], incoming[index]);
        } else {
            return incoming[index] || item;
        }
    });
};

// Added by sephora-jsx-loader.js
module.exports = TestTarget.prototype; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js

